import { useEffect, useState } from "react";

import { message } from "antd";
import CustomTable from "../../../components/antdCustom/CustomTable";
import { getPcidRepair } from "../../../services/api";
import { MySubtitleH4 } from "../../../styled/publicTag";

const innerWidth = window.innerWidth;

const LogModal = ({ s_pcid }) => {
  console.log("s_pcid = ", s_pcid);

  // 返修紀錄資料
  const [s_tableData, set_s_tableData] = useState([]);

  // 表格載入狀態
  const [s_isTableLoading, set_s_isTableLoading] = useState(false);

  // 分頁資訊
  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    pageItemNumber: 10,
    totalItems: 0,
    pageSize: 10,
  });

  const scrollY = "";

  useEffect(() => {
    // 取得返修紀錄
    const call_getPcidRepair = async () => {
      set_s_isTableLoading(true);
      try {
        const res = await getPcidRepair({ pcid: s_pcid });

        if (res.status === true) {
          console.log(res);
          const data = res.data || [];
          set_s_tableData(data);
          setPageInfo((prev) => ({
            ...prev,
            totalItems: data.length,
          }));
          message.success(res.msg);
        } else {
          set_s_tableData([]);
          setPageInfo((prev) => ({
            ...prev,
            totalItems: 0,
          }));
          message.error(res.msg);
        }
      } catch (e) {
        console.log("---------- api getPcidRepair error ----------");
        console.log(e);
      } finally {
        set_s_isTableLoading(false);
      }
    };

    call_getPcidRepair();
  }, []);

  const tableColumns = [
    {
      title: "生產序號",
      dataIndex: "pcid",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${150}px`,
    },
    {
      title: "掃碼內容",
      dataIndex: "itemcode",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${250}px`,
    },
    {
      title: "項目名稱",
      dataIndex: "itemNM",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${200}px`,
    },
    {
      title: "掃碼項目",
      dataIndex: "itemanchor",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${250}px`,
    },
    {
      title: "掃碼時間",
      dataIndex: "updtTstr",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${150}px`,
    },
  ];

  return (
    <CustomTable
      loading={s_isTableLoading}
      size={innerWidth <= 1440 ? "16px" : null} // 表頭字體大小
      scroll={{ x: "max-content", y: scrollY }}
      columns={tableColumns}
      dataSource={s_tableData.map((item, index) => {
        return {
          key: index,
          ...item,
        };
      })}
      pagination={{
        defaultCurrent: 1,
        total: pageInfo.totalItems,
        defaultPageSize: 30,
        showSizeChanger: true,
        // pageSize: pageInfo.pageSize,
        pageSize: 30,
        // pageSizeOptions: ["10", "20", "30"],
        pageSizeOptions: [10, 20, 30, 40],
        onChange: (current, size) => {
          setPageInfo({
            ...pageInfo,
            pageSize: size,
          });
        },
        showTotal: (total, range) => (
          <MySubtitleH4>
            共 {total} 項 ， 正在顯示第{range[0]}到{range[1]}項
          </MySubtitleH4>
        ),
      }}
    />
  );
};

export default LogModal;
